module.exports = __webpack_public_path__ + "assets/img/serve7.8f5760b1.png";